import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Shield, AlertTriangle, ArrowRight } from "lucide-react";

const KlartextCheckTeaser = () => {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden bg-gradient-to-br from-blue-50 via-indigo-50 to-slate-50">
      {/* Background decorations */}
      <div className="absolute top-10 left-10 w-40 h-40 bg-blue-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-10 w-56 h-56 bg-indigo-200/30 rounded-full blur-3xl"></div>
      
      <div className="mx-auto w-full max-w-7xl px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          {/* Left: Icon & Badge */}
          <div className="flex-shrink-0">
            <div className="relative">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-gradient-to-br from-primary to-blue-600 flex items-center justify-center shadow-2xl">
                <Shield className="h-16 w-16 md:h-20 md:w-20 text-white" />
              </div>
              <div className="absolute -top-2 -right-2 w-12 h-12 rounded-full bg-red-500 flex items-center justify-center shadow-lg animate-pulse">
                <AlertTriangle className="h-6 w-6 text-white" />
              </div>
            </div>
          </div>
          
          {/* Center: Content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 rounded-full bg-blue-100 px-4 py-2 text-sm font-semibold text-blue-700 mb-4">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-600"></span>
              </span>
              NEU: Kostenloser Sicherheitscheck
            </div>
            
            <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4">
              <span className="bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
                Klartext-Check
              </span>{" "}
              gegen Internet-Betrug
            </h2>
            
            <p className="text-lg md:text-xl text-slate-600 mb-6 max-w-2xl">
              Verdächtige E-Mail oder SMS erhalten? Prüfen Sie in Sekunden, ob es sich um 
              <strong className="text-slate-800"> Phishing oder Betrug</strong> handelt – kostenlos und anonym.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link to="/klartext-check">
                <Button className="group rounded-xl bg-gradient-to-r from-primary to-blue-600 px-8 py-4 text-lg font-bold text-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all">
                  <Shield className="mr-2 h-5 w-5" />
                  Jetzt testen
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
              
              <span className="text-slate-500 text-base">
                100% kostenlos • Keine Anmeldung nötig
              </span>
            </div>
          </div>
          
          {/* Right: Example pills */}
          <div className="hidden xl:flex flex-col gap-3">
            <div className="flex items-center gap-3 bg-white rounded-xl px-5 py-3 shadow-md border border-red-200">
              <div className="w-4 h-4 rounded-full bg-red-500"></div>
              <span className="text-slate-700 font-medium">"Paket beim Zoll..."</span>
            </div>
            <div className="flex items-center gap-3 bg-white rounded-xl px-5 py-3 shadow-md border border-yellow-200">
              <div className="w-4 h-4 rounded-full bg-yellow-500"></div>
              <span className="text-slate-700 font-medium">"Konto gesperrt..."</span>
            </div>
            <div className="flex items-center gap-3 bg-white rounded-xl px-5 py-3 shadow-md border border-green-200">
              <div className="w-4 h-4 rounded-full bg-green-500"></div>
              <span className="text-slate-700 font-medium">"Bestellung versandt"</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KlartextCheckTeaser;
